module.exports = __webpack_public_path__ + "static/media/teagasc.da43da58.jpg";